import React from 'react'
import classnames from 'classnames'
import { FormattedMessage, defineMessages } from 'react-intl'
import { GemGrid } from 'src/Components/Gem'
import { Button, Panel, Format, InlineTextLock, Text } from 'src/Components'
import { Waypoint } from 'react-waypoint'
import { ScrolledIntoView, EVENTS_LABELS } from 'src/constants/trackingEvents'
import { oneTimeTagEventDispatcher } from 'src/helpers/tagManager'
import { OVERLAY_HELPERS } from 'src/constants/navigation'

import styles from './CashOut.module.scss'

const CO_META = defineMessages({
  title: {
    id: 'Homeowners.document.cashout.title',
    defaultMessage: 'Cash out'
  }
})

const scrollIntoView = oneTimeTagEventDispatcher(ScrolledIntoView, {
  eventLabel: EVENTS_LABELS.CashOutModule
})

const CashOut = ({
  className,
  equity,
  gems,
  showDetail,
  selectedDetail,
  selectedGem,
  show,
  hide,
  question,
  locked,
  topic,
  intl
}) => (
  <Panel
    data-qa='CashOutCard'
    className={classnames(
      styles.card,
      showDetail && styles.hasSelected,
      className
    )}
  >
    <Panel.Heading className={styles.heading} id='equity'>
      <FormattedMessage
        id='Homeowner.equity.heading'
        defaultMessage='Your house has built {equity} worth of equity. How could you use it?'
        values={{
          equity: (
            <Text color='pink' element='span' nowrap>
              <Format.Currency>
                <InlineTextLock enabled={Boolean(locked)}>
                  <Format.Number abbreviate value={equity} />
                </InlineTextLock>
              </Format.Currency>
            </Text>
          )
        }}
      />
    </Panel.Heading>
    <Waypoint onEnter={scrollIntoView} bottomOffset='75%'>
      <div />
    </Waypoint>
    <GemGrid
      className={styles.grid}
      data={gems}
      selectedDetail={selectedDetail}
      selectedGem={selectedGem}
      show={show}
      hide={hide}
      collapsed={showDetail}
      question={question}
      topic={topic}
      overlayPanelName={OVERLAY_HELPERS.cashout.overlay}
      overlayPanelFrom={OVERLAY_HELPERS.cashout.getOrigin()}
      overlayPanelTitle={
        intl ? intl.formatMessage(CO_META.title) : CO_META.title.defaultMessage
      }
    />
    <Button.Close
      className={classnames(styles.closeButton, showDetail && styles.show)}
      onClick={hide}
    />
  </Panel>
)

export default CashOut
